var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 223,
    viewBox: "0 0 316 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4666 79.3444L168.342 8.46563C170.203 5.43659 175.655 1.19594 182.577 8.46563C189.499 15.7353 243.703 58.7472 269.94 79.3444V81.8882",
    stroke: "#FB7C51",
    strokeWidth: 0.660815
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.131 141.063C132.337 120.967 78.7465 80.7744 78.7465 80.7744V203.585",
    stroke: "#FB7C51",
    strokeWidth: 0.846391
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.697 140.932L270.009 81.3582L268.702 206.045",
    stroke: "#FB7C51",
    strokeWidth: 0.846391
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4788 208.612L268.549 206.123C246.309 188.387 201.329 152.419 189.392 140.482C177.455 128.545 168.812 130.521 165.152 135.495C159.146 141.501 138.914 159.031 106.031 181.103C73.1485 203.175 71.4632 210.414 87.4788 208.612Z",
    stroke: "#FB7C51",
    strokeWidth: 0.846391
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 30.5312V98.6353L158.94 141.341L164.545 135.736C170.149 130.546 173.042 131.602 173.226 131.602C180.024 131.271 187.211 137.957 189.955 141.341L246.495 98.6353V58.4428L218.584 30.5312H101.355Z",
    fill: "#FEFEFE",
    stroke: "#FB7C51",
    strokeWidth: 0.660815
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.583 33.3225C218.583 39.5974 218.583 45.8724 218.583 52.1473C218.583 54.7989 218.583 57.4505 218.583 60.1021C218.583 61.8175 220.103 61.1599 221.513 61.3736C225.739 62.0138 230.532 61.6439 234.771 61.4977C238.631 61.3646 242.715 60.9549 246.494 60.9549",
    stroke: "#FB7C51",
    strokeWidth: 0.660815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.596 44.0409C139.137 44.0409 154.677 44.0583 170.217 44.0409C182.242 44.0274 194.252 43.7319 206.274 43.7319",
    stroke: "#FB7C51",
    strokeWidth: 1.63381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.597 52.5786C130.18 53.1069 136.807 53.2429 143.459 53.3184C157.074 53.473 165.205 53.0811 178.812 53.3184",
    stroke: "#FB7C51",
    strokeWidth: 1.63381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2287 21.6558C82.8986 25.7811 88.6112 29.7803 94.4024 33.7164",
    stroke: "#FB7C51",
    strokeWidth: 1.32163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5258 8.21924C94.0159 13.117 96.4926 18.2921 96.7465 23.4923",
    stroke: "#FB7C51",
    strokeWidth: 1.32163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M109.696 9.43351C109.055 12.5728 108.281 15.659 107.472 18.7559C107.219 19.7276 106.612 20.4695 106.279 21.394",
    stroke: "#FB7C51",
    strokeWidth: 1.32163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M314.501 205.032C305.59 203.412 296.595 203.901 287.542 203.901C283.254 203.901 279.009 204.134 274.743 204.572C272.373 204.815 270.368 204.661 268.123 205.41",
    stroke: "#FB7C51",
    strokeWidth: 1.98244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 210.687C47.9887 210.687 58.3764 211.082 68.6213 210.687C70.0756 210.632 71.1696 209.933 72.6432 209.933C74.5819 209.933 76.1996 209.434 78.0685 209.2C80.3648 208.913 82.5809 209.312 84.8764 208.802",
    stroke: "#FB7C51",
    strokeWidth: 1.98244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.533 216.343C154.666 215.369 172.953 215.966 191.1 215.966C214.247 215.966 237.394 215.966 260.54 215.966C262.984 215.966 265.428 215.966 267.872 215.966C268.022 215.966 270.39 215.966 267.956 215.966C255.522 215.966 243.08 216.459 230.67 217.181C217.731 217.934 204.755 218.916 192.001 221.308C187.992 222.059 188.913 221.999 192.001 221.999C210.462 221.999 228.924 221.999 247.385 221.999",
    stroke: "#FB7C51",
    strokeWidth: 1.98244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.873 205.969C264.81 206.248 144.567 208.173 84.829 209.101",
    stroke: "#FB7C51",
    strokeWidth: 1.98244
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.853 120.42C134.926 104.136 120.222 79.2555 36.8215 110.008C18.8553 107.873 -12.1127 99.4371 7.74464 82.7794C27.602 66.1217 62.8251 57.6861 77.9544 55.5505",
    stroke: "#FB7C51",
    strokeWidth: 0.846391,
    strokeDasharray: "6.77 6.77"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M242.207 53.8479C238.388 50.5217 237.107 42.6867 262.533 37.9564C287.959 33.2261 296.779 11.3478 298.011 1",
    stroke: "#FB7C51",
    strokeWidth: 0.846391,
    strokeDasharray: "6.77 6.77"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.497,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.43,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158.363,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175.295,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 192.227,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 209.16,
    y: 73.2236,
    width: 13.5475,
    height: 13.5475,
    rx: 2.5,
    stroke: "#FB7C51"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.458,
    cy: 148.133,
    r: 34.2015,
    fill: "#FEFEFE",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.048 150.994L158.106 159.052C160.995 161.941 165.597 162.189 168.78 159.626L198.066 136.045",
    stroke: "#FB7C51",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/OtpIcon.85831ce232221060a3b6216592154343.svg";
export { ForwardRef as ReactComponent };